<template>
  <b-card title="Consumi per fasce">
    <b-row v-if="loading">
      <b-col>
        <b-alert variant="warning" :show="loading">Caricamento fasce orarie...</b-alert>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col sm="8">
         <apexchart height="400" type="bar" :options="chart.options" :series="chart.series"></apexchart>
      </b-col>
      <b-col sm="4">
        <apexchart width="100%" type="pie" :options="pie.options" :series="pie.series"></apexchart>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
var moment = require('moment');

export default {
  name: "Slots",
  props:['monthFrom', 'monthTo', 'sites'],

  data() {
    return {
      loading: true,
      chart: {
        options: {
          chart: {
            stacked: true
          },

          colors: ['#5A97AA', '#595959', '#D8D8D8', '#E91E63', '#173741'],
          height: 350,
          type: 'bar',
          plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%'
            },
          },
          dataLabels: {
            enabled: false,
            formatter: (v, o) => {
              return this.chart.series[o  .seriesIndex].name
            }
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              formatter: x => x.toFixed(0) + " [kWh]"
            },
            title: {
              text: "Consumi [kWh]"
            },
          }
        },
        series: []
      },
      pie: {
        options: {
          chart: {
            type: 'donut'
          },
          legend: {
            position: 'bottom',
          },
          colors: ['#5A97AA', '#595959', '#D8D8D8', '#E91E63', '#173741'],
          labels: []
        },
        series: []
      }
    }
  },

  mounted() {
    this.refresh()
  },

  methods: {
    refresh() {
      let params = {
        sitesGuids: this.sites.map(s => s.guid),
        fromMonth: this.monthFrom,
        toMonth: this.monthTo
      }

      this.loading = true
      this.$store.dispatch("charts/mslots", params).then( (data) => {
        this.loading = false
        this.chart.series = data.data.map(v => {
          return {
            name: v.slot,
            data: v.values
          }
        })

        let pieOptions = _.cloneDeep(this.pie.options)
        pieOptions.labels = data.data.map(v => v.slot)
        this.pie.options = pieOptions


        this.pie.series = data.data.map(v => {
          return v.values.reduce( (a, b) => a + b )
        })

        let chartOptions = _.cloneDeep(this.chart.options)
        chartOptions.xaxis = {
          type: 'category',
          categories: data.months.map(m => m + "-01"),
          labels: {
            formatter: (v) => {
              let m = v.split('-')
              return this.monthLabels[parseInt(m[1]) - 1] + " '" + m[0].substr(2)
            }
          }
        }
        this.chart.options = chartOptions
      })
    }
  },

  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
  },

  watch: {
    monthFrom(v) {
      this.refresh()
    },
    monthTo(v) {
      this.refresh()
    },
    customer(v) {
      if(v) {
          this.refresh()
      }
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Slots/Slots.vue